import { Component, Input} from '@angular/core';
import * as _ from "lodash";

@Component({
    selector: 'impact-analysis-deployment',
    template: require('./impact-analysis-deployment.html'),
    styles: [require('./impact-analysis-deployment.scss')]
})
export class ImpactAnalysisDeploymentComponent {
    public processData: any;
    public isCollapsed: boolean;
    public isAdditionalOptionsCollapsed: boolean


    @Input() public set items(data: any) {
        if (data) {
            this.processData = data
        }
    }


    constructor() {
        this.isCollapsed = true;
        this.isAdditionalOptionsCollapsed = true;

    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-deployment-ang7/impact-analysis-deployment.ts